<script lang="ts">
    import {fade} from 'svelte/transition';
    import type {ValueEditorErrorMessagesLocalizations} from './error-messages-localization.service';
    import type {FormController} from '../forms/types';
    import {createErrorMessagesId} from './utils';
    import type {ValueEditorSize} from '../../types';
    import {getContext} from 'svelte';
    import type {EditorsLocalizationFunction} from 'shared/value-editors/localizations/types';
    import {ERRORS_LOCALIZE} from 'shared/value-editors/context-keys';

    export let formController: FormController<any>;
    export let errors = formController.getErrors$();
    export let forceShowErrors: boolean;
    export let size: ValueEditorSize;
    export let customClass = '';
    export let inline = false;
    export let standalone = false;

    const touched$ = formController.isTouched$();
    const errorMessagesId = createErrorMessagesId({editorId: formController.id, editorName: formController.name});

    const localize = getContext<EditorsLocalizationFunction<ValueEditorErrorMessagesLocalizations>>(ERRORS_LOCALIZE);
</script>

{#if (forceShowErrors || $touched$) && $errors.length > 0}
    <div id={errorMessagesId}
         class="error-messages"
         class:error-messages-inline={inline}
         role="alert"
         aria-live="polite">

        {#each $errors as error, index (error)}
            <div class="error-message size-{size} {customClass}"
                 class:error-message-standalone={standalone}
                 style:--index="{index}"
                 data-error="{error}"
                 transition:fade|global={{duration:200}}>

                {localize(error)}
            </div>
        {/each}
    </div>
{/if}

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .error-messages-inline {
        display: inline;
    }

    .error-message {
        display: inline-block;
        text-align: center;
        color: @state-danger-text;
        border-color: @state-danger-text;
        border-style: solid;
        border-width: 0 1px 1px 1px;
        border-radius: 0 0 @border-radius-base @border-radius-base;
        background-color: #eeeeee;
        position: absolute;
        padding: 0 5px;
        min-width: 20%;
        max-width: 85%;
        z-index: 10;
        right: calc(10% + 20px * var(--index));
        box-shadow: 0 2px 6px -2px lighten(@state-danger-text, 20%);

        &.error-message-standalone {
            position: relative;
            right: auto;
            border-radius: @border-radius-base;
            border: 1px solid @state-danger-text;
            box-shadow: 0 0 2px lighten(@state-danger-text, 20%);
        }

        &.size-sm,
        &.size-xs {
            font-size: 12px;
        }

        &.size-xs {
            line-height: 1;
            padding-top: 1px;
            padding-bottom: 1px;
        }
    }
</style>